var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 43.315,
    viewBox: "0 0 41 43.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(-3 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48157",
    "data-name": "Group 48157",
    transform: "translate(3 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55364",
    "data-name": "Path 55364",
    d: "M15.6,38.5H11.119A1.118,1.118,0,0,0,10,39.619V44.1a1.118,1.118,0,0,0,1.119,1.119H15.6A1.118,1.118,0,0,0,16.714,44.1V39.619A1.118,1.118,0,0,0,15.6,38.5",
    transform: "translate(-3.333 -1.899)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55365",
    "data-name": "Path 55365",
    d: "M37.6,38.5H33.119A1.118,1.118,0,0,0,32,39.619V44.1a1.118,1.118,0,0,0,1.119,1.119H37.6A1.118,1.118,0,0,0,38.714,44.1V39.619A1.118,1.118,0,0,0,37.6,38.5",
    transform: "translate(-4.381 -1.899)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55366",
    "data-name": "Path 55366",
    d: "M42.357,15.5H40.119a1.119,1.119,0,1,0,0,2.238h2.238a1.119,1.119,0,0,1,1.119,1.119V26.69a1.119,1.119,0,0,1-1.119,1.119H40.119a1.119,1.119,0,1,0,0,2.238h2.238a3.361,3.361,0,0,0,3.357-3.357V18.857A3.361,3.361,0,0,0,42.357,15.5",
    transform: "translate(-4.714 -3.78)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55367",
    "data-name": "Path 55367",
    d: "M6.357,17.738H8.6a1.119,1.119,0,1,0,0-2.238H6.357A3.361,3.361,0,0,0,3,18.857V26.69a3.361,3.361,0,0,0,3.357,3.357H8.6a1.119,1.119,0,0,0,0-2.238H6.357A1.119,1.119,0,0,1,5.238,26.69V18.857a1.119,1.119,0,0,1,1.119-1.119",
    transform: "translate(-3 -3.78)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55368",
    "data-name": "Path 55368",
    d: "M30.564,4.5H15.483C10.805,4.5,7,8.855,7,14.21V42.26a1.017,1.017,0,0,0,.943,1.079H38.105a1.017,1.017,0,0,0,.943-1.079V14.21c0-5.354-3.805-9.71-8.483-9.71",
    transform: "translate(-2.524 -4.5)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55369",
    "data-name": "Path 55369",
    d: "M39.048,13.619a1.041,1.041,0,0,0-.943-1.119H7.943A1.041,1.041,0,0,0,7,13.619v12.31a1.041,1.041,0,0,0,.943,1.119H38.105a1.041,1.041,0,0,0,.943-1.119Z",
    transform: "translate(-2.524 -3.976)",
    fill: "#dff9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55370",
    "data-name": "Path 55370",
    d: "M23,12.5h2.238V27.048H23Z",
    transform: "translate(-0.619 0.524)",
    fill: "#387f75",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55371",
    "data-name": "Path 55371",
    d: "M30.81,27.5H14.524C12.029,27.5,10,30.01,10,33.1v8.952H35.333V33.1c0-3.085-2.029-5.6-4.524-5.6",
    transform: "translate(0.833 1.292)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55372",
    "data-name": "Path 55372",
    d: "M35.262,7.5H15.119a1.119,1.119,0,1,0,0,2.238H35.262a1.119,1.119,0,1,0,0-2.238",
    transform: "translate(-1.69 0.357)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55373",
    "data-name": "Path 55373",
    d: "M32.786,31.5H17.119a1.119,1.119,0,0,0,0,2.238H32.786a1.119,1.119,0,1,0,0-2.238",
    transform: "translate(-1.452 2.187)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55374",
    "data-name": "Path 55374",
    d: "M32.786,34.5H17.119a1.119,1.119,0,1,0,0,2.238H32.786a1.119,1.119,0,1,0,0-2.238",
    transform: "translate(-1.452 2.429)",
    fill: "#dff9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralBus);
export default __webpack_public_path__ + "static/media/university-general-bus.5ddf1e4e06affee80573d5ca1c5a33b4.svg";
export { ForwardRef as ReactComponent };